import PropTypes from 'prop-types';
import { cmrApplicableRegion } from '../../config/tenant/tenant.config';
import _ from '../../utils/LodashImports';
import { getProductCategory } from '../../utils/product/productUtils';
import { getVariant } from '../../utils/variant';
import { Styles } from './UnifiedCMRInformation.style';

const UnifiedCMRInformation = ({ maxInstallments, appCtx, regionCode, product }) => {
  const { siteConfig } = appCtx;
  const { textDictionary } = siteConfig;
  const { ACCUMULATE, CMR_POINTS, INTEREST_FREE_INSTALLMENT, OPEN_CMR_ACCOUNT, CMR_ACCOUNT_DEFAULT } = textDictionary;
  const isCMRAperturaInTab = _.get(appCtx, 'siteConfig.toggles.isCMRAperturaInTab', false);
  const validCmrUrl = _.get(appCtx, 'siteConfig.endpoints.SO_COM_APERTURA_URL_VALID_CMR', '');
  const invalidCmrUrl = _.get(appCtx, 'siteConfig.endpoints.SO_COM_APERTURA_URL_INVALID_CMR', '');
  const isGlobalCategoryEnabled = _.get(appCtx, 'siteConfig.toggles.isGlobalCategoryEnabled', false);
  const { currentVariant: currentVariantId, variants = [], isOutOfStock } = product;
  const { cmrSavings, cmrPoints } = getVariant(variants, currentVariantId);
  const isCmrValid = !!(cmrApplicableRegion[regionCode] && cmrPoints);

  const hasSavings = typeof cmrSavings === 'string' && cmrSavings !== '0';
  const sellerId = _.get(product, 'variants[0].offerings[0].sellerId', '');
  const symbol = _.get(product, 'variants[0].prices[0].symbol', '$');
  let cmrAperturaUrl = hasSavings ? validCmrUrl : invalidCmrUrl;
  if (cmrAperturaUrl) {
    const fromIndex = cmrAperturaUrl.indexOf('&from');
    // eslint-disable-next-line prefer-const
    let [firsPart, secondPart] =
      fromIndex !== -1 ? [cmrAperturaUrl.slice(0, fromIndex), cmrAperturaUrl.slice(fromIndex)] : [cmrAperturaUrl, ''];
    firsPart += `&seller=${sellerId}`;
    if (isGlobalCategoryEnabled) {
      const gCategory = getProductCategory(product, 'G');
      firsPart += `&category=${gCategory}`;
    } else {
      const jCategory = getProductCategory(product);
      firsPart += `&category=${jCategory}`;
    }
    cmrAperturaUrl = firsPart + secondPart;
  }
  return (
    <div className="cmr-info-container">
      <div className="installments-text">
        <span className="cmr-icon" />
        {maxInstallments ? (
          <span>
            {' '}
            {maxInstallments} {INTEREST_FREE_INSTALLMENT}{' '}
          </span>
        ) : (
          <span> </span>
        )}
        <a href={cmrAperturaUrl} target={isCMRAperturaInTab ? '_blank' : ''} rel="noreferrer">
          <span className="cmr-text">
            {cmrSavings ? `${OPEN_CMR_ACCOUNT} ${symbol.trim()}${cmrSavings}` : CMR_ACCOUNT_DEFAULT}
          </span>
        </a>
      </div>
      {isCmrValid && !isOutOfStock && (
        <div id="unified-cmr-points" className="cmr-points">
          {ACCUMULATE} {cmrPoints} {CMR_POINTS}
        </div>
      )}
      <style jsx>{Styles}</style>
    </div>
  );
};

UnifiedCMRInformation.defaultProps = {
  maxInstallments: undefined,
};

UnifiedCMRInformation.propTypes = {
  maxInstallments: PropTypes.number,
  appCtx: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  regionCode: PropTypes.string.isRequired,
};
export default UnifiedCMRInformation;
